import React, {Component} from 'react';
import {ContentMap} from '../config/contentMap';
import store from '../../store';
import { disableLanguageSelectorToggle } from '../../actions/commonActions';
import { setLocaleWithFallback } from '../../actions/index';
import { preferredLanguageName } from '../../i18n/config';

// i18n
import { Translate } from 'react-redux-i18n';
import './formUnavailablePage.css';

class FormUnavailable extends Component{

    state = {
        errorId : 0
    }

    componentDidMount(){
        if(this.props.searchData.specializationInfo && !this.props.searchData.specializationInfo.government){
            this.setState({errorId:0});
        }
        else if(this.props.searchData.errorCode === "40301" && this.props.searchData.data && this.props.searchData.data.level === "Platinum Certified"){
            this.setState({errorId:2});
        }
        else if(this.props.searchData.errorCode === "41008")
        {   
            this.setState({errorId:1});
        }
        else if(this.props.searchData.errorCode === "40301" || this.props.searchData.message === "Unauthorized access") {
            this.setState({errorId:0});
        }
        else if(this.props.searchData.isPartnerContact && this.props.searchData.programType !== "APC")
        {
            this.setState({errorId:0});
        }
        else if(!this.props.searchData.isPartnerContact)
        {
            this.setState({errorId:0});
        }
    }

    render(){
        
        var TAG = ContentMap['unavailable'][this.state.errorId];
     
        return (<div>
            <TAG {...this.props} />
        </div>);
    }
}


  
export default FormUnavailable;